import { create } from "zustand";

type SessionError =
  | "RefreshAccessTokenError"
  | "RefreshAccessTokenTransientError"
  | undefined;

type SessionStore = {
  accessToken: string | undefined;
  username: string | undefined;
  sessionError: SessionError;
  setAccessToken: (value: string | undefined) => void;
  setUsername: (value: string | undefined) => void;
  setSessionError: (value: SessionError) => void;
};

const useSessionStore = create<SessionStore>((set) => ({
  accessToken: undefined,
  username: undefined,
  sessionError: undefined,
  setAccessToken: (value: string | undefined) =>
    set(() => ({ accessToken: value })),
  setUsername: (value: string | undefined) => set(() => ({ username: value })),
  setSessionError: (value: SessionError) => set(() => ({ sessionError: value })),
}));

export default useSessionStore;
